import React, { useEffect, useState, useLayoutEffect, useRef } from "react";
import "../css/VUP_dash.css";
import { FxmsData } from "../fxms/datas/FxData";
import { FxIndcManagerChart } from "./components/FxIndcManagerChart";
import { FxIndcManagerChartPareto } from "./components/FxIndcManagerChartPareto";
import { FxKepcoPowerChart } from "./components/FxKepcoPowerChart";
import { EngInfo } from "./EngInfo";
import { FxIndcManagerChartBar } from "./components/FxIndcManagerChartBar";
import { FxWindow } from "../fxms/windows/FxWindows";
// import { WeatherInfo } from "./components/WeatherInfo";
import { NavLink, useParams } from "react-router-dom";
import { getDay } from "./common/commonMethod";
import {
  vupCompanyDash10001,
  vupCompanyDash10002,
  vupCompanyDash10003,
  vupCompanyDash10004,
  vupCompanyDashKepcoEpwr,
} from "./api/endpoints/vupCompanyDashboardApi";
import {
  getToday,
  getPrevMonth,
  getYesterday,
  MyCompInloNo,
  getIcon,
  getEnergyDataList,
  getArrOfDay,
  engUsageValSum,  
} from "./helper/vupComDash.helper";
import CommMeterStatus from "./vupComDash/CommMeterStatus";
import AlamNotify from "./AlamNotify";

/*산단대시보드*/
export const VupComDash = (props) => {
  const [complexInloNo, setComplexInloNo] = useState(MyCompInloNo(props));
  const realTimePowerChartRef = useRef(null);
  let engList = FxmsData.getDatas("energy");
  const user = FxmsData.getUser();
  /* API fetch 데이터 */
  const [dataRows, setDataRows] = useState({
    alarmFetchData: [], //알림
    thisMonthEnergyCost: [], //월간 에너지 사용금액 당월
    prevMonthEnergyCost: [], //월간 에너지 사용금액 전월
    prevMonthEnergyAmount: [], //월간 에너지 사용량 전월
    thisMonthEnergyAmount: [], //월간 에너지 사용량 당월
    realTimePowerUsage: [], // 실시간 전력 사용현황 당일
    prevTimePowerUsage: [], // 전일 전력 사용현황 당일
    commMetStatus: [], //통신현황(Communication status) 및 계측기 상태(Meter status)
  
  });

  
  
  const [consAmtNowData, setConsAmtNowData] = useState(0);
  const [totalconsData, setTotalconsData] = useState(0);
  const [instEpwrPeak, setInstEpwrPeak] = useState(0);

  //공장 콤보박스 관련
  const [plantList, setPlantList] = useState([]);
  const [selectedPlant, setSelectedPlant] = useState("");
  const isKepcoComplex = ["11000", "14000"].includes(String(complexInloNo));
  const openRealTimePowerDetail = () => {
    realTimePowerChartRef.current?.openDetail?.();
  };

  let tmpInloList = FxmsData.getDatas("inlo", {
    inloClCd: "COMPLEX",
    complexInloNo: complexInloNo,
  });
  let tmpPlantList = FxmsData.getDatas("inlo", {
    inloClCd: "PLANT",
    complexInloNo: complexInloNo,
  });

  useEffect(() => {
    getData();
    if (tmpInloList.length != 0) {
      FxWindow.showNavigator(tmpInloList[0].inloName);
    } else {
      FxWindow.showNavigator("산단 정보 없음");
    }

    if (tmpInloList.length !== 0) {
      setPlantList(tmpPlantList);
    }
    getAlarmFunc();
  }, [complexInloNo]);

  useEffect(() => {
    //[1000*60*10 : 10분, 1000*15 : 15초, 1000*60*60*6 : 6시간]
    const refreshDashBoard15sec = setInterval(() => {
      getAlarmFunc();
      console.log("refreshDashBoard15sec:", new Date().toLocaleString());
    }, 1000 * 15);
    return () => clearInterval(refreshDashBoard15sec);
  }, []);

  /*useLayoutEffect(() => {
    const interval = setInterval(() => {
      if (complexInloNo !== undefined && complexInloNo !== "") {
        getData();
        console.log("refreshDashBoard05min:", new Date().toLocaleString());
      }
    }, 1000 * 60);
    return () => clearInterval(interval);
  }, []);*/

  const getAlarmFunc = async () => {
    let params = { inloNo: complexInloNo };
    const fetchDataAlarm = await vupCompanyDash10001(params);
    setDataRows((prev) => ({ ...prev, alarmFetchData: fetchDataAlarm }));
  };

  const getData = async () => {
    let tempResponse = {};

    const fetchDataCommMeterStatus = await vupCompanyDash10002({
      complexInloNo: complexInloNo,
    });
    tempResponse = getEnergyDataList(
      fetchDataCommMeterStatus.sensor_state_list
    );
    tempResponse.comm = fetchDataCommMeterStatus.comm_state;
    setDataRows((prev) => ({ ...prev, commMetStatus: tempResponse }));

    const powerParams = {
      startDate: getToday("yyyymmdd"), // 당일만 조회
      endDate: getToday("yyyymmdd"),
      engId: "EPWR",
      complexInloNo: complexInloNo,
    };

    const fetchDataPower = isKepcoComplex
      ? await vupCompanyDashKepcoEpwr(powerParams)
      : await vupCompanyDash10004(powerParams);

    tempResponse = {};
    if (isKepcoComplex) {
      const normalizedPower = Array.isArray(fetchDataPower)
        ? fetchDataPower.map((row) => ({
            ...row,
            psDate: row.psDate || row.psdate,
            consAmt: parseFloat(
              row.consAmt ?? row.consamt ?? row.consInstVal ?? row.consinstval ?? 0
            ),
            consInstVal: parseFloat(
              row.consInstVal ?? row.consinstval ?? row.consAmt ?? row.consamt ?? 0
            ),
          }))
        : [];
      const sortedPower = [...normalizedPower].sort(
        (a, b) => Number(a.psDate || 0) - Number(b.psDate || 0)
      );
      const today = getToday("yyyymmdd");
      tempResponse.today = getArrOfDay(sortedPower, today);
      tempResponse.befor = [];
      if (!tempResponse.today || tempResponse.today.length === 0) {
        tempResponse.today = sortedPower;
      }
    } else {
      const epwrList = getEnergyDataList(fetchDataPower, "EPWR")["EPWR"] || [];
      tempResponse = epwrList;
      // 날짜 분리해서 값을 얻음
      tempResponse.today = getArrOfDay(epwrList, getToday("yyyymmdd"));
      tempResponse.befor = getArrOfDay(
        epwrList,
        getYesterday(getToday("yyyymmdd"))
      );
    }

    setDataRows((prev) => ({
      ...prev,
      realTimePowerUsage: tempResponse.today || [],
    }));
    setDataRows((prev) => ({
      ...prev,
      prevTimePowerUsage: tempResponse.befor || [],
    }));

    const todayPowerUsage = tempResponse.today || [];
    const toNumber = (value) => parseFloat(value || 0);
    const getConsValue = (entry) =>
      parseFloat(entry?.consInstVal ?? entry?.consAmt ?? 0);

    //당일 전력 사용량
    let epwrTotalAmt = todayPowerUsage.reduce(
      (prev, curr) => prev + toNumber(curr.consAmt ?? curr.consInstVal),
      0
    );
    //현재전력 부하
    let epwrNow = 0;
    //당일 피크
    let epwrPeak = 0;
    if (todayPowerUsage.length !== 0) {
      epwrNow = getConsValue(todayPowerUsage[todayPowerUsage.length - 1]);
      epwrPeak = todayPowerUsage.reduce(
        (prev, curr) => {
          const val = getConsValue(curr);
          return val > prev ? val : prev;
        },
        -Infinity
      );
    }
    if (!isFinite(epwrPeak)) {
      epwrPeak = 0;
    }
    epwrTotalAmt = epwrTotalAmt/4
    setTotalconsData(epwrTotalAmt);
    setConsAmtNowData(epwrNow);
    setInstEpwrPeak(epwrPeak);

    /*const fetchDataPrevMonth = await vupCompanyDash10003({
      month: getPrevMonth("yyyymm"),
      complexInloNo: complexInloNo,
    });*/

    const fetchDataThisMonth = await vupCompanyDash10003({
      month: getToday("yyyymm"),
      complexInloNo: complexInloNo,
      day: getDay(-1).replace(/-/gi, "")
    });
    tempResponse = [];
    tempResponse.thisMon = engUsageValSum(fetchDataThisMonth);
    /* tempResponse.BeforeMon = engUsageValSum(fetchDataPrevMonth);

    setDataRows((prev) => ({
      ...prev,
      prevMonthEnergyAmount: tempResponse.BeforeMon,
    }));*/
    setDataRows((prev) => ({
      ...prev,
      thisMonthEnergyAmount: tempResponse.thisMon,            
    }));

    /*const prevMonthCostFetchData = await vupCompanyDash10003({
      month: getPrevMonth("yyyymm"),
      complexInloNo: complexInloNo,
    });*/

    const thisMonthCostFetchData = await vupCompanyDash10003({
      month: getToday("yyyymm"),
      complexInloNo: complexInloNo,
      day: getDay(-1).replace(/-/gi, "")
    });

    setDataRows((prev) => ({
      ...prev,
      thisMonthEnergyCost: thisMonthCostFetchData,
    }));
    /*setDataRows((prev) => ({
      ...prev,
      prevMonthEnergyCost: prevMonthCostFetchData,
    }));*/
  };

  /* 공장 콤보박스 핸들링*/
  const handleChangePlant = (event) => {
    const value = event.target.value;
    setSelectedPlant(value);
  };

  const getPlantCombobox = () => {
    let tmpHtml = [];

    console.log("plantList>>>", plantList);

    tmpHtml.push(
      <select
        style={{ margin: "0px" }}
        value={selectedPlant}
        onChange={handleChangePlant}
      >
        <option value=""> 전체 </option>
        {plantList.map((obj) => (
          <option value={obj.plantInloNo}> {obj.plantInloName}</option>
        ))}
      </select>
    );
    tmpHtml.push(
      <NavLink
        style={{ padding: "3px 10px" }}
        className="bigBtn fl_r"
        to={ selectedPlant == 200201 || selectedPlant == 200207? "/comp-vup-johab-plant-dash/" + selectedPlant : "/comp-vup-plant-dash/" + selectedPlant}
        //state={{ plantInloNo: selectedPlant }}
        onClick={(e) => {
          if (!selectedPlant || selectedPlant === "") {
            e.preventDefault();
            FxWindow.alert("공장을 선택해주세요.", true);
          }
        }}
      >
        공장 대시보드 바로가기
      </NavLink>
    );

    return tmpHtml;
  };

  return (
    <div id="wrapper">
      <div id="dashPart">
      {/* <WeatherInfo/> */}
        <div style={{ display: "inline-block", float: "right" }}>
          {getPlantCombobox()}
        </div>
        <div className="alertMessage">
          <span>알림</span>
          {dataRows &&
          dataRows.alarmFetchData &&
          dataRows.alarmFetchData.length !== 0 ? (
            <AlamNotify dataRows={dataRows} />
          ) : (
            <p>발생된 알람이 없습니다.</p>
          )}
        </div>

        <div className = {complexInloNo=== '14000'? "lineGroup mt20": "lineGroup" }>
          <div className={complexInloNo=== '14000'? "grayBox line2": "grayBox line1" }>
            <CommMeterStatus
              dataRows={dataRows}
              complexInloNo={complexInloNo}
            />
          </div>
          <div className={complexInloNo=== '14000'? "grayBox line2": "grayBox line1" }>
            <CommMeterStatus
              engId={"EPWR"}
              dataRows={dataRows}
              complexInloNo={complexInloNo}
            />
          </div>
          <div className={complexInloNo=== '14000'? "grayBox line2": "grayBox line1" }>
            <CommMeterStatus
              engId={"STEAM"}
              dataRows={dataRows}
              complexInloNo={complexInloNo}
            />
          </div>
          {complexInloNo=== '14000'? null :
           <div className={complexInloNo=== '14000'? "grayBox line2": "grayBox line1" }>
            <CommMeterStatus
              engId={"AIR"}
              dataRows={dataRows}
              complexInloNo={complexInloNo}
            />
          </div>   }
        </div>
        <div className={complexInloNo === '14000' ? "lineGroup mt20" : "lineGroupNew mt20"}>
          <div className={complexInloNo === '14000' ? "grayBox line2" : "grayBox line2New"}>
            <div className="gb_title">
              <img src={getIcon("EPWR")} />
              <h2 onClick={openRealTimePowerDetail}>실시간 전력 사용현황</h2>
            </div>
            <div class="unitFlex">
              <p><span class="unit">당일 전력 사용량</span> <b> {Math.round(totalconsData).toLocaleString("ko-KR")} kWh</b></p>
              <p><span class="unit">현재 전력 부하</span> <b> {Math.round(consAmtNowData).toLocaleString("ko-KR")} kW</b></p>
            </div>                   
            <div className="chartArea">
              {isKepcoComplex ? (
                <FxKepcoPowerChart
                  ref={realTimePowerChartRef}
                  key={"실시간전력사용현황_KEPCO"}
                  dataToday={dataRows.realTimePowerUsage}
                  dataBefor={dataRows.prevTimePowerUsage}
                />
              ) : (
                <FxIndcManagerChartPareto
                  ref={realTimePowerChartRef}
                  key={"실시간전력사용현황"}
                  energy={"EPWR"}
                  dataToday={dataRows.realTimePowerUsage}
                  dataBefor={dataRows.prevTimePowerUsage}
                />
              )}
            </div>
          </div>
          {complexInloNo=== '14000'? null :
          <div className="grayBox">
          <EngInfo
            complexInloNo={complexInloNo}
            complexInloName = {tmpInloList.length != 0 ? tmpInloList[0].inloName : ""}
            dashId = 'VupComDash'
            engId={"AIR"}
            energy={engList}
          />
        </div>
          }
          <div className= {complexInloNo=== '14000'? "grayBox line2": "grayBox" }>
            <EngInfo
              complexInloNo={complexInloNo}
              complexInloName = {tmpInloList.length != 0 ? tmpInloList[0].inloName : ""}
              dashId = 'VupComDash'
              engId={"STEAM"}
              energy={engList}
            />
          </div>
        </div>
        
        <div className="lineGroupNew mt20">
          <div className="grayBox2 line3New">
            <div className="gb_title mb20">
              <h2>당월 에너지 사용량</h2><h2 style={{fontSize : "14px"}}>({getToday("yyyy")+'-'+getToday("mm")+'-01'+"~"+getDay(-1)})</h2>
            </div>
            <table className="factory_energy">
              <tr>
                {complexInloNo!== '14000' && 
                 <td>
                 <div className="chart-wrapper">
                   <div className="chartArea center">
                     <FxIndcManagerChartBar
                       thisMon={dataRows.thisMonthEnergyAmount}
                       BeforeMon={null}
                       month={getToday("yyyymm")}               
                       beforeMonth={null}
                       engId="AIR"
                     />
                   </div>
                 </div>
               </td>}               
                <td>
                  <div className="chart-wrapper">
                    <div className="chartArea center">
                      <FxIndcManagerChartBar
                        thisMon={dataRows.thisMonthEnergyAmount}
                        BeforeMon={null}
                        month={getToday("yyyymm")}               
                        beforeMonth={null}
                        engId="STEAM"
                      />
                    </div>
                  </div>
                </td>
                <td>
                  <div className="chart-wrapper">
                    <div className="chartArea center">
                      <FxIndcManagerChartBar
                        thisMon={dataRows.thisMonthEnergyAmount}
                        BeforeMon={null}
                        month={getToday("yyyymm")}               
                        beforeMonth={null}
                        engId="EPWR"
                      />
                    </div>
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <div className="grayBox line1">
            <div className="gb_title mb20">
              <h2>당월 에너지 사용금액</h2>
              <h2 style={{fontSize: "14px"}}>
                ({getToday("yyyy")+'-'+getToday("mm")+'-01'+"~"+getDay(-1)})
              </h2>
            </div>
            <div style={{ 
              width: "100%",
              height: "calc(100% - 60px)", // gb_title의 높이만큼 뺌
              position: "relative"
            }}>
              <div className="chartArea center" style={{
                width: "100%",
                height: "100%",
                position: "relative",
                overflow: "hidden",
                backgroundColor: "#313131",
                display: "flex",
                alignItems: "center",
              }}>
                <FxIndcManagerChart
                  title="월간 에너지사용금액"
                  allValues={dataRows.thisMonthEnergyCost}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
